export type HttpClientAuthenticationProvider = (request: RequestInit) => RequestInit;
